import React from 'react';
import SelectorPartidasPrograma, { fechaMasTemprana, especialidadDesdePartida, construirActMapPrograma, obtenerHojasProgramaDedup } from './SelectorPartidasPrograma';

/* ── Estilos inline para evitar conflictos con App.css (.modal-overlay y .modal-content
      están redefinidos ahí como side-panel, lo que rompe un modal centrado) ── */

const S = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0, 0, 0, 0.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
    pointerEvents: 'auto',
    backdropFilter: 'blur(2px)',
  },
  container: {
    width: '100%',
    maxWidth: '520px',
    maxHeight: '90vh',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '16px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    animation: 'mem-slide 0.25s ease',
  },
  header: {
    background: 'linear-gradient(135deg, #111827 0%, #2d4a6d 100%)',
    padding: '20px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
  },
  headerTitle: {
    margin: 0,
    fontSize: '17px',
    fontWeight: 700,
    color: '#ffffff',
    letterSpacing: '-0.2px',
  },
  closeBtn: {
    background: 'rgba(255,255,255,0.15)',
    border: 'none',
    color: '#ffffff',
    fontSize: '16px',
    lineHeight: 1,
    cursor: 'pointer',
    padding: '6px 8px',
    borderRadius: '6px',
    transition: 'background 0.15s',
    flexShrink: 0,
  },
  body: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    background: '#ffffff',
    overflowY: 'auto',
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#374151',
  },
  footer: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
    padding: '16px 24px',
    borderTop: '1px solid #f3f4f6',
    background: '#f9fafb',
    flexShrink: 0,
  },
  cancelBtn: {
    padding: '9px 20px',
    background: '#ffffff',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    color: '#374151',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  submitBtn: {
    padding: '9px 24px',
    background: '#111827',
    border: 'none',
    borderRadius: '8px',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 700,
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
  },
  divider: {
    border: 'none',
    borderTop: '1px solid #f3f4f6',
    margin: '4px 0',
  },
};

function ModalEditarMaterial({
  visible, onCerrar,
  materialSections,
  editMaterialFields, setEditMaterialFields,
  editMatModoPrograma, setEditMatModoPrograma,
  actividadesMaterial, setActividadesMaterial,
  actMapPrograma, setActMapPrograma,
  obtenerActividadesKpi,
  saveEditMaterial,
  editMaterialId,
}) {
  if (!visible) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    await saveEditMaterial(editMaterialId);
  };

  return (
    <>
      <style>{`
        @keyframes mem-slide {
          from { opacity: 0; transform: translateY(-16px) scale(0.98); }
          to   { opacity: 1; transform: translateY(0)     scale(1);    }
        }
      `}</style>

      <div style={S.overlay} onClick={onCerrar}>
        <div style={S.container} onClick={e => e.stopPropagation()}>

          <div style={S.header}>
            <h2 style={S.headerTitle}>Editar Material</h2>
            <button type="button" style={S.closeBtn} onClick={onCerrar}>✕</button>
          </div>

          <form onSubmit={handleSubmit} style={{ display: 'contents' }}>
            <div style={S.body}>
              <div style={S.fieldGroup}>
                <label style={S.label}>Nombre del material</label>
                <input
                  className="task-input"
                  type="text"
                  placeholder="Nombre del Material"
                  value={editMaterialFields.text}
                  onChange={(e) => setEditMaterialFields(f => ({ ...f, text: e.target.value }))}
                  required
                  autoComplete="off"
                />
              </div>

              <hr style={S.divider} />

              <div style={S.fieldGroup}>
                <label style={S.label}>Partida y fecha</label>
                <div style={{ display: 'flex', gap: '6px', margin: '4px 0' }}>
                  <button type="button"
                    onClick={() => { setEditMatModoPrograma(false); setEditMaterialFields(f => ({ ...f, partidaPrograma: [] })); }}
                    style={{ padding: '5px 12px', borderRadius: '6px', fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer', border: '1.5px solid', borderColor: !editMatModoPrograma ? '#111827' : '#e2e8f0', background: !editMatModoPrograma ? '#111827' : '#f8fafc', color: !editMatModoPrograma ? '#fff' : '#64748b' }}
                  >Manual</button>
                  <button type="button"
                    onClick={() => {
                      setEditMatModoPrograma(true);
                      if (actividadesMaterial.length === 0 && obtenerActividadesKpi) {
                        obtenerActividadesKpi().then(acts => {
                          setActividadesMaterial(obtenerHojasProgramaDedup(acts));
                          if (setActMapPrograma) setActMapPrograma(construirActMapPrograma(acts));
                        });
                      }
                    }}
                    style={{ padding: '5px 12px', borderRadius: '6px', fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer', border: '1.5px solid', borderColor: editMatModoPrograma ? '#111827' : '#e2e8f0', background: editMatModoPrograma ? '#111827' : '#f8fafc', color: editMatModoPrograma ? '#fff' : '#64748b' }}
                  >Desde Programa</button>
                </div>

                {editMatModoPrograma ? (
                  actividadesMaterial.length === 0 ? (
                    <span style={{ fontSize: '12px', color: '#6b7280' }}>No hay programa importado</span>
                  ) : (
                    <div>
                      <SelectorPartidasPrograma
                        actividadesDisponibles={actividadesMaterial}
                        seleccionadas={editMaterialFields.partidaPrograma || []}
                        onCambiar={(nuevoArray) => setEditMaterialFields(f => ({
                          ...f,
                          partidaPrograma: nuevoArray,
                          dueDate: fechaMasTemprana(nuevoArray) || f.dueDate,
                          specialty: especialidadDesdePartida(nuevoArray, actMapPrograma) || f.specialty
                        }))}
                      />
                      {editMaterialFields.dueDate && (
                        <div style={{ fontSize: '0.72rem', color: '#6b7280', marginTop: 3 }}>
                          Fecha inicio (la más temprana): <strong>{editMaterialFields.dueDate}</strong>
                        </div>
                      )}
                      {editMaterialFields.specialty && (
                        <div style={{ marginTop: 6 }}>
                          <label style={{ ...S.label, display: 'block', marginBottom: 4 }}>Sección (desde Programa)</label>
                          <input
                            className="task-input"
                            type="text"
                            value={editMaterialFields.specialty}
                            disabled
                            readOnly
                            style={{ background: '#f3f4f6', color: '#374151', cursor: 'not-allowed' }}
                          />
                        </div>
                      )}
                    </div>
                  )
                ) : (
                  <>
                    <select
                      className="task-input"
                      value={editMaterialFields.specialty}
                      onChange={(e) => setEditMaterialFields(f => ({ ...f, specialty: e.target.value }))}
                      required
                      style={{ marginBottom: '8px' }}
                    >
                      <option value="">-- Seleccionar Sección --</option>
                      {[...materialSections].sort((a, b) => a.name.localeCompare(b.name)).map((section) => (
                        <option key={section.id} value={section.name}>
                          {section.name}
                        </option>
                      ))}
                      <option value="__nueva__">+ Nueva Sección...</option>
                    </select>

                    {editMaterialFields.specialty === '__nueva__' && (
                      <input
                        className="task-input"
                        type="text"
                        placeholder="Escribir nueva sección"
                        onChange={(e) => setEditMaterialFields(f => ({ ...f, specialty: e.target.value }))}
                        autoFocus
                        style={{ marginBottom: '8px' }}
                      />
                    )}

                    <input
                      className="date-input"
                      type="date"
                      value={editMaterialFields.dueDate}
                      onChange={(e) => setEditMaterialFields(f => ({ ...f, dueDate: e.target.value }))}
                      required
                    />
                  </>
                )}
              </div>

            </div>

            <div style={S.footer}>
              <button type="button" style={S.cancelBtn} onClick={onCerrar}>Cancelar</button>
              <button type="submit" style={S.submitBtn}>Guardar Cambios</button>
            </div>
          </form>

        </div>
      </div>
    </>
  );
}

export default ModalEditarMaterial;
